export enum Endpoints {
    // App Related Web View
    mobileQrisCheckStatus = "/app/qris_check",
    mobileQrisDisplay = "/app/qris_display",
    mobileQrisCheckOrder = "/app/qris_order_check",
    referralDetail = "/app/referral_detail",
    // Coverage Area
    coverageAreaPolygons = "/outlet/coverage_polygons",
    coverageAreaMapsLinkToCoordinate = "/outlet/maps_link_to_coordinate",
    // CRM
    notificationWebViewCreation = "/bo/create_notification_web",
    notificationWebViewDisplay = "/bo/get_notification_web",
    pushCrm = "/crm/push",
    redirectWebCreation = "/bo/create_redirect_web",
    redirectWebGet = "/bo/get_redirect_web",
    // Driver
    driverChangeStatus = "/driver/change_status",
    driverCancelDelivery = "/driver/cancel_delivery",
    driverDeliveryDone = "/driver/delivery_done",
    driverSignIn = "/driver/sign_in",
    driverGetOrderList = "/driver/get_orders",
    driverInputOrder = "/driver/input_order",
    driverOrderDetail = "/driver/order_detail",
    // Order Form
    orderFormSubmitGerobak = "/bo/form/create_order/submit_gerobak",
    orderFormAutoComplete = "/bo/form/create_order/auto_complete",
    orderFormGetContent = "/bo/form/create_order/contents",
    orderSaveDraft = "/bo/form/create_order/save_draft",
    orderFormSubmitRequest = "/bo/form/create_order/submit",
    orderFormValidateSubmission = "/bo/form/create_order/validate_submission",
    orderFormVoucherChecker = "/bo/form/create_order/voucher_checker",
    orderSendOtp = "/bo/form/create_order/send_otp_voucher",
    queueOutletList = "/bo/ops_view/queue_outlet_list",
    queueViewer = "/bo/ops_view/queue_viewer",
    orderPreview = "/bo/ops_view/order_preview",
    // Upload Image
    uploadImage = "/upload/image",
    // Completion
    completionInfo = "/bo/dashboard/info",
    // Inventory
    getSoFormSubmitHistory = "/inventory/v2/so/form_get_history",
    getWasteFormSubmitHistory = "/inventory/v2/waste/form_get_history",
    getCompleteness = "/inventory/v2/completeness_so_waste_history",
    getTransferHistory = "/inventory/v2/transfer/history",
    getTransferFixItems = "/inventory/v2/transfer/get_fix_items",
    uploadMapWeeklyCsv = "/inventory/v2/raw_mat_csv",
    getReceiptHistory = "/inventory/v2/receipt/history",
    getReceiptHistoryLocationOptions = "/inventory/v2/receipt/history/location_options",
    getReceiptHistoryDetail = "/inventory/v2/receipt/history/detail",
    inventoryGetMenuPackaging = "/inventory/v2/menu_packaging/",
    inventoryCreateMenuPackaging = "/inventory/v2/menu_packaging/create",
    inventoryDeleteMenuPackaging = "/inventory/v2/menu_packaging/delete",
    inventoryEditMenuPackaging = "/inventory/v2/menu_packaging/edit",
    bomDashboardHomepage = "/inventory/v2/bom",
    getBomDetail = "/inventory/v2/bom/detail",
    getBomItemsAndUnits = "/inventory/v2/bom/items-and-units",
    getExistingBomResultItemIds = "/inventory/v2/bom/existing-results",
    saveBom = "/inventory/v2/bom/save",
    getGeneralDOI = "/inventory/v2/general_doi",
    getOutletStock = "/inventory/v2/stock",
    getAllOutletStock = "/inventory/v2/get_all_outlet_stock",
    getMasterItemList = "/inventory/v2/master_item_dashboard",
    getMasterItemDetail = "/inventory/v2/master_item_dashboard/detail",
    createMasterItem = "/inventory/v2/master_item_dashboard",
    updateMasterItem = "/inventory/v2/master_item_dashboard",
    adjustmentFormSubmit = "/inventory/v2/adjustment",
    adjustmentFormGetProductionList = "/inventory/v2/adjustment/list-production",
    adjustmentFormGetProductionDetail = "/inventory/v2/adjustment/detail-production",
    adjustmentFormGetSOList = "/inventory/v2/adjustment/list-so",
    adjustmentFormGetSODetail = "/inventory/v2/adjustment/detail-so",
    adjustmentFormGetWasteList = "/inventory/v2/adjustment/list-waste",
    adjustmentFormGetWasteDetail = "/inventory/v2/adjustment/detail-waste",
    adjustmentFormGetReceiptList = "/inventory/v2/adjustment/list-receipt",
    adjustmentFormGetReceiptDetail = "/inventory/v2/adjustment/detail-receipt",
    adjustmentFormGetTransferList = "/inventory/v2/adjustment/list-transfer",
    adjustmentFormGetTransferDetail = "/inventory/v2/adjustment/detail-transfer",
    adjustmentFormVoidTransfer = "/inventory/v2/adjustment/transfer/void",
    adjustmentFormGetToVendorList = "/inventory/v2/adjustment/list-to-vendor",
    adjustmentFormGetToVendorDetail = "/inventory/v2/adjustment/detail-to-vendor",
    adjustmentFormGetItemOptions = "/inventory/v2/adjustment/item-options",
    adjustmentFormGetLocationOptions = "/inventory/v2/adjustment/location-options",
    adjustmentFormGetVendorsOptions = "/inventory/v2/adjustment/vendors-options",
    getVendorList = "/inventory/v2/vendor_item_dashboard/vendor_list",
    getVendorCurrentItems = "/inventory/v2/vendor_item_dashboard/vendor_current_items",
    getVendorItemOptions = "/inventory/v2/vendor_item_dashboard/vendor_item_options",
    submitVendorItems = "/inventory/v2/vendor_item_dashboard/submit_items",
    submitNewVendor = "/inventory/v2/vendor_item_dashboard/submit_vendor",
    // sold out dashboard
    getSoldOutMenu = "/bo/dashboard/get_sold_out_menu",
    getSoldOutItem = "/bo/dashboard/get_sold_out_item",
    // delete account
    getOTP = "/users/login",
    deleteAccount = "/users/delete_user_by_phone",
    // menu to menu prep
    getMenuPrepBomMenuList = "/inventory/v2/menu_preparation_bom/menu_list",
    getMenuPrepBomItemOptions = "/inventory/v2/menu_preparation_bom/item_options",
    createMenuPrepBom = "/inventory/v2/menu_preparation_bom",
    getMenuPrepBomDetail = "/inventory/v2/menu_preparation_bom/menu_detail",
    // finish cooking dashboard
    getFinishCookingOrderList = "/bo/dashboard/get_finish_cooking_order",
    updateFinishCookingOrder = "/bo/dashboard/update_finish_cooking_order",
    // new adjustemnt
    newSOAdjustmentPreloading = "/inventory/v2/adjustment/so/preloading",
    newSOAdjustmentGetFormDetail = "/inventory/v2/adjustment/so/form_detail",
    newSOAdjustmentSubmit = "/inventory/v2/adjustment/so/submit",
    newSOAdjustmentGetForms = "/inventory/v2/adjustment/so/get_forms",

    newWasteAdjustmentPreloading = "/inventory/v2/adjustment/waste/preloading",
    newWasteAdjustmentGetFormDetail = "/inventory/v2/adjustment/waste/form_detail",
    newWasteAdjustmentSubmit = "/inventory/v2/adjustment/waste/submit",
    newWasteAdjustmentGetForms = "/inventory/v2/adjustment/waste/get_forms",

    // Form ops reminder
    formOpsReminderPreloading = "/operational/form_ops_reminder/preloading",
    formOpsReminderCreate = "/operational/form_ops_reminder/create",
    formOpsReminderUpdate = "/operational/form_ops_reminder/update",
    formOpsReminderGetList = "/operational/form_ops_reminder/get_list",
    formOpsReminderGetDetail = "/operational/form_ops_reminder/get_detail",
    formOpsReminderSoftDelete = "/operational/form_ops_reminder/soft_delete",
    formOpsReminderSendOnce = "/operational/form_ops_reminder/send_once",

    // Sold out cms editor
    soldOutCmsPreloading = "/sold_out_editor/preloading",
    soldOutCmsItemToAffectedMenuList = "/sold_out_editor/items_to_affected_menus_list",
    soldOutCmsSubmit = "/sold_out_editor/submit_items_to_affected_menus",
    soldOutCmsDeleteMenus = "/sold_out_editor/delete_menus",

    // Shopee order dashboard
    getShopeeOrders = "/bo/dashboard/shopee_order/get_data",
    setCollectedByDriver = "/bo/dashboard/shopee_order/collected",

    // Runchise check sync dashboard
    getAllOutletWithId = "/outlet/get_all_outlet_with_id",
    getUnsyncMenus = "/bo/dashboard/get_unsync_menus",
}
